class DictQueue {
    fetch = () => { throw Error('fetch 函数不能为空'); };
    queue = new Map();
    timer = null;
    // eslint-disable-next-line no-magic-numbers
    delay = 500;
    constructor(fetch) {
        this.fetch = fetch;
    }

    setFetchFn (fetch) {
        this.fetch = fetch;
    }

    queueUp (codes) {
        if (!codes) return;
        const promise = new Promise(resolve => {
            this.queue.set(resolve, codes);
        });
        clearTimeout(this.timer);
        this.timer = setTimeout(this.fetchDicts.bind(this), this.delay);
        return promise;
    }
    /**
     * 拷贝一份queue
     * @param {Map} queue
     * @returns Map
     */
    cloneQueue(queue) {
        try {
            return new Map(queue)
        } catch (err) {
            console.error(err)
        }
        return queue
    }
    // eslint-disable-next-line
    async fetchDicts () {
        const clonedQueue = this.cloneQueue(this.queue)
        let result = [...clonedQueue.values()].reduce((res, item) => {
            const arr = item.split(',');
            return res.concat(arr);
        }, []);
        result = [...new Set(result)].join(',');
        const res = await this.fetch(result);
        if (res.code === '0') {
            clonedQueue.forEach((codes, resolve) => {
                const resp = codes.split(',').reduce((result, code) => {
                    result.data[code] = res.data[code];
                    return result;
                }, {
                    code: '0',
                    data: {}
                });
                resolve(resp);
            });
        }
    }
}

export default DictQueue;
